import actionTypes from 'constants/RAConstants/actionTypes';
import { RAGoalOfInvestmentStep } from 'components/RAComponents/RAWizard/RASteps/RAGoalOfInvestmentStep';
import { RAInvestmentExperienceStepContainer } from 'components/RAComponents/RAWizard/RASteps/RAInvestmentExperienceStepContainer';
import { RAAbilityToTakeOnLossStep } from 'components/RAComponents/RAWizard/RASteps/RAAbilityToTakeOnLossStep';
import { RAPercentageInvestment } from 'components/RAComponents/RAWizard/RASteps/RAPercentageInvestment';
import { RAIncomesExpensesStep } from 'components/RAComponents/RAWizard/RASteps/RAIncomesExpensesStep';
import { RAInvestmentHorizonStep } from 'components/RAComponents/RAWizard/RASteps/RAInvestmentHorizonStep';
import { wizzardStatus } from 'utilities/RASuitabilityTestHelper';
import { SustainabilityContainer } from 'components/RAComponents/RAWizard/RASteps/Sustainability/SustainabilityContainer';
import { InvestmentFactorsContainer } from 'components/RAComponents/RAWizard/RASteps/Sustainability/InvestmentFactorsContainer';
import { RAKnowledgeExperienceStepsContainer } from 'components/RAComponents/RAWizard/RASteps/RAKnowledgeExperienceSteps/RAKnowledgeExperienceStepsContainer';

const defaultSteps = [
    {
        key: 0,
        title: 'suitabilityTest-firstMenuTitle',
        icon: 'icon-college',
        available: true,
        finished: false,
        skipped: false,
        steps: [
            {
                key: 0,
                component: RAKnowledgeExperienceStepsContainer,
                title: 'suitabilityTest-firstMenuFirstSubtitle',
                active: true,
                finished: false,
                available: true,
                question: '101',
            },
            {
                key: 1,
                component: RAKnowledgeExperienceStepsContainer,
                title: 'suitabilityTest-firstMenuSecondSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '102',
            },
            {
                key: 2,
                component: RAKnowledgeExperienceStepsContainer,
                title: 'suitabilityTest-firstMenuThirdSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '103',
                withWarning: true,
            },
            {
                key: 3,
                component: RAKnowledgeExperienceStepsContainer,
                title: 'suitabilityTest-firstMenuThirdSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '104',
            },
            {
                key: 4,
                component: RAInvestmentExperienceStepContainer,
                title: 'suitabilityTest-firstMenuFourthSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '105',
            },
        ],
    },
    {
        key: 1,
        title: 'suitabilityTest-secondMenuTitle',
        icon: 'icon-objectives',
        available: false,
        finished: false,
        skipped: false,
        steps: [
            {
                key: 0,
                component: RAGoalOfInvestmentStep,
                title: 'suitabilityTest-secondMenuFirstSubtitle',
                active: true,
                finished: false,
                available: true,
                question: '217',
            },
            {
                key: 1,
                component: RAInvestmentHorizonStep,
                title: 'suitabilityTest-secondMenuSecondSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '218',
            },
            {
                key: 2,
                component: RAAbilityToTakeOnLossStep,
                title: 'suitabilityTest-secondMenuThirdSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '219',
            },
        ],
    },
    {
        key: 2,
        title: 'suitabilityTest-thirdMenuTitle',
        icon: 'icon-investments-savings',
        available: false,
        finished: false,
        skipped: false,
        steps: [
            {
                key: 0,
                component: RAIncomesExpensesStep,
                title: 'suitabilityTest-thirdMenuFirstSubtitle',
                active: true,
                finished: false,
                available: true,
                question: '320',
            },
            {
                key: 1,
                component: RAPercentageInvestment,
                title: 'suitabilityTest-thirdMenuSecondSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '322',
            },
            {
                key: 2,
                component: RAKnowledgeExperienceStepsContainer,
                title: 'suitabilityTest-thirdMenuThirdSubtitle',
                active: false,
                finished: false,
                available: false,
                question: '323',
            },
        ],
    },
    {
        key: 3,
        title: 'suitabilityTest-fourthMenuTitle',
        icon: 'icon-sustainability',
        available: false,
        finished: false,
        skipped: false,
        steps: [
            {
                key: 0,
                component: SustainabilityContainer,
                hidden: true,
                question: '401',
            },
            {
                key: 1,
                component: InvestmentFactorsContainer,
                hidden: true,
                questions: ['402', '403', '404', '405', '500'],
            },
        ],
    },
];

export const initialState = {
    steps: defaultSteps,
    currentStep: 0,
    currentSubStep: 0,
    lastSubStep: false,
};

export const RASuitabilityTestWizardReducer = (state = initialState, action) => {
    const { steps } = state;
    switch (action.type) {
        case actionTypes.RA_TEST_FETCH_STEPS:
            return initialState;
        case actionTypes.RA_TEST_FINALIZE_SUBSTEP: {
            const currentstep = action.data.step;
            const currentSubstep = action.data.substep;
            const nextSubstep = currentSubstep + 1;
            const size = state.steps?.[currentstep]?.steps.length;
            const last = size === nextSubstep + 1;

            const subtstepsWithCurrentSubStepUpdated = steps?.[currentstep]?.steps.map(step => {
                if (step.key === currentSubstep) {
                    return {
                        ...step,
                        active: false,
                        finished: true,
                    };
                }

                return step;
            });

            const subtstepsWithNextSubStepUpdated = subtstepsWithCurrentSubStepUpdated?.map(step => {
                if (step.key === nextSubstep) {
                    return {
                        ...step,
                        active: true,
                        available: true,
                    };
                }

                return step;
            });

            const stepsUpdated = steps.map(step => {
                if (step.key === currentstep) {
                    return {
                        ...step,
                        steps: subtstepsWithNextSubStepUpdated,
                    };
                }

                return step;
            });

            return {
                ...state,
                steps: stepsUpdated,
                currentSubStep: nextSubstep,
                lastSubStep: last,
            };
        }
        case actionTypes.RA_TEST_FINALIZE_STEP: {
            const currentstepFinal = action.data.step;
            const currentSubstepFinal = action.data.substep;
            const currentStep = action.data.step + 1;
            const currentSubStep = 0;
            const stepsFinal = state.steps;

            if (stepsFinal.length < currentStep) {
                return state;
            }

            const subStepsWithCurrentSubstepFinalUpdated = stepsFinal?.[currentstepFinal].steps.map(step => {
                if (step.key === currentSubstepFinal) {
                    return {
                        ...step,
                        active: false,
                        finished: true,
                    };
                }

                return step;
            });

            const stepFinalWithCurrentStepFinalUpdated = stepsFinal.map(step => {
                if (step.key === currentstepFinal) {
                    return {
                        ...step,
                        finished: false,
                        steps: subStepsWithCurrentSubstepFinalUpdated,
                    };
                }

                return step;
            });

            if (stepFinalWithCurrentStepFinalUpdated.length > currentStep) {
                const substepsFinalWithCurrentSubStepUpdated = stepFinalWithCurrentStepFinalUpdated?.[
                    currentStep
                ].steps.map(step => {
                    if (step.key === currentSubStep) {
                        return {
                            ...step,
                            active: true,
                            available: true,
                        };
                    }

                    return step;
                });

                const stepsFinalWithCurrentStepUpdated = stepFinalWithCurrentStepFinalUpdated.map(step => {
                    if (step.key === currentStep) {
                        return {
                            ...step,
                            available: true,
                            steps: substepsFinalWithCurrentSubStepUpdated,
                        };
                    }

                    return step;
                });

                return {
                    ...state,
                    steps: stepsFinalWithCurrentStepUpdated,
                    currentStep,
                    currentSubStep,
                    lastSubStep: false,
                };
            }

            return {
                ...state,
                steps: stepFinalWithCurrentStepFinalUpdated,
                currentStep: currentstepFinal,
                currentSubStep: currentSubstepFinal,
                lastSubStep: true,
            };
        }
        case actionTypes.RA_TEST_PREV_STEP: {
            const currentStepPrev = action.data.currentStep;
            const currentSubStepPrev = action.data.currentSubStep;
            const { steps } = state;

            const getCurrentPrevStepAndSubtep = () => {
                if (currentSubStepPrev === 0) {
                    const currentPrevStep = currentStepPrev - 1;
                    const previousStepWasSkipped = steps[currentPrevStep].skipped;

                    return {
                        currentPrevStep,
                        currentPrevSubStep: previousStepWasSkipped ? 0 : steps[currentPrevStep].steps.length - 1,
                    };
                }

                return {
                    currentPrevStep: currentStepPrev,
                    currentPrevSubStep: currentSubStepPrev - 1,
                };
            };

            const { currentPrevStep, currentPrevSubStep } = getCurrentPrevStepAndSubtep();

            return {
                ...state,
                currentStep: currentPrevStep,
                currentSubStep: currentPrevSubStep,
            };
        }
        case actionTypes.RA_TEST_NEXT_STEP: {
            const currentStepNext = action.data.step;
            const currentSubStepNext = action.data.substep;
            const { steps } = state;
            const length = steps?.[currentStepNext].steps.length - 1;

            const getCurrentNextStepAndSubtep = () => {
                if (currentSubStepNext === length) {
                    return {
                        currentNextStep: currentStepNext + 1,
                        currentNextSubStep: 0,
                    };
                }

                return {
                    currentNextStep: currentStepNext,
                    currentNextSubStep: currentSubStepNext + 1,
                };
            };

            const { currentNextStep, currentNextSubStep } = getCurrentNextStepAndSubtep();

            return {
                ...state,
                currentStep: currentNextStep,
                currentSubStep: currentNextSubStep,
            };
        }
        case actionTypes.RA_TEST_GOTO_STEP:
            return {
                ...state,
                currentStep: action.data,
                currentSubStep: 0,
            };

        case actionTypes.RA_TEST_GOTO_SUB_STEP: {
            const goToStep = action.data.key;
            const goToSubStep = action.data.index;

            return {
                ...state,
                currentStep: goToStep,
                currentSubStep: goToSubStep,
            };
        }
        case actionTypes.RA_TEST_RETAKE_TEST: {
            const { retakeToStep, retakeToSubStep } = wizzardStatus(action.data);
            let isLastSubStep = false;
            const { steps } = state;
            let subSteps = steps?.[retakeToStep].steps;

            const finshSteps = steps.map((step, i) => {
                if (i <= retakeToStep) {
                    subSteps = step.steps.map((item, index) => {
                        if (i !== retakeToStep || index < retakeToSubStep) {
                            return { ...item, finished: true, active: false, available: true };
                        }

                        if (
                            (retakeToStep === 1 && retakeToSubStep === 2) ||
                            (retakeToStep === 0 && retakeToSubStep === 3) ||
                            (retakeToStep === 2 && retakeToSubStep === 2)
                        ) {
                            isLastSubStep = true;

                            return { ...item, finished: false, active: true, available: true };
                        }

                        return item;
                    });

                    if (steps.length === retakeToSubStep) {
                        return { ...step, finished: false, available: true, active: true, steps: subSteps };
                    }
                    if (steps.length < retakeToSubStep + 1) {
                        return { ...step, finished: true, available: true, active: true, steps: subSteps };
                    }

                    return { ...step, finished: false, available: true, active: true, steps: subSteps };
                }

                return step;
            });

            return {
                ...state,
                steps: finshSteps,
                currentStep: retakeToStep,
                currentSubStep: retakeToSubStep,
                lastSubStep: isLastSubStep,
            };
        }

        case actionTypes.RA_SKIP_TO_NEXT_TEST: {
            const { currentStep, steps, currentSubStep } = state;
            const nextStep = currentStep + 1;

            const updatedActiveAndFinishedSteps = steps.map(step => {
                if (step.key === currentStep) {
                    const { steps: substeps } = step;
                    const updatedFinishedSubsteps = substeps.map(substep => {
                        if (substep.key !== currentSubStep) {
                            return {
                                ...substep,
                                finished: false,
                                active: false,
                            };
                        }

                        return { ...substep, finished: false, active: true };
                    });

                    const updatedStep = { ...step, steps: updatedFinishedSubsteps };

                    return { ...updatedStep, active: false, finished: false, skipped: true };
                }

                if (step.key === nextStep) {
                    return { ...step, active: true, available: true, finished: false };
                }

                return step;
            });

            return {
                ...state,
                steps: updatedActiveAndFinishedSteps,
                currentStep: nextStep,
                currentSubStep: 0,
            };
        }

        case actionTypes.RA_REMOVE_STEP_FROM_SKIPPED_STEPS: {
            const { currentStep, steps } = state;
            const updatedSkippedStepsAndChangedAvailableSteps = steps.map(step => {
                if (currentStep === step.key) {
                    return { ...step, skipped: false };
                }

                if (currentStep + 1 === step.key) {
                    return { ...step, active: false, available: false };
                }

                return step;
            });

            return {
                ...state,
                steps: updatedSkippedStepsAndChangedAvailableSteps,
            };
        }

        default:
            return state;
    }
};
